import React, {
    useEffect,
    useMemo,
    useState
} from 'react';

import Modal from 'react-modal';

import {
    ModalEconomiaContenido,
    ModalEconomiaCabecera,
    ModalEconomiaTitulo,
    ModalEconomiaSubtitulo,
    BotonCerrarModal,

    ModalSeccion,
    ModalSeccionTitulo,
    ModalAcciones,
    ModalScrollContenido,

    BotonPrincipal,
    BotonSecundario,

    CobroFormulario,
    CobroCampo,
    CobroLabel,
    CobroInput,
    CobroSelect,

    SinInformacion
} from '../../Css/StyledEstadisticasCobros.js';


Modal.setAppElement(
    '#root'
);


/*
====================================
FECHA DE HOY
====================================
*/

const getFechaHoy = () => {

    const hoy =
        new Date();


    const year =
        hoy.getFullYear();


    const month =
        String(
            hoy.getMonth() + 1
        ).padStart(
            2,
            '0'
        );


    const day =
        String(
            hoy.getDate()
        ).padStart(
            2,
            '0'
        );


    return `${year}-${month}-${day}`;

};


/*
====================================
NOMBRE PACIENTE
====================================
*/

const getNombrePaciente = (
    paciente
) => {

    if (
        !paciente
    ) {

        return 'Paciente';

    }


    return `${paciente.apellido || ''}, ${paciente.nombre || ''}`
        .replace(
            /^,\s*/,
            ''
        )
        .trim();

};


/*
====================================
ID PACIENTE
====================================
*/

const getIdPaciente = (
    paciente
) => {

    return (

        paciente
            ?.id_paciente ||

        paciente
            ?.id ||

        ''

    );

};


/*
====================================
MODAL
====================================
*/

const VincularPacienteCentroModal = ({

    isOpen,

    onClose,

    centro,

    pacientes,

    acuerdos,

    onGuardar,

    guardando

}) => {


    /*
    ====================================
    ESTADOS
    ====================================
    */

    const [
        idPaciente,
        setIdPaciente
    ] = useState(
        ''
    );


    const [
        fechaDesde,
        setFechaDesde
    ] = useState(
        getFechaHoy()
    );


    const [
        errorFormulario,
        setErrorFormulario
    ] = useState(
        ''
    );


    /*
    ====================================
    REINICIAR AL ABRIR
    ====================================
    */

    useEffect(() => {

        if (
            !isOpen
        ) {

            return;

        }


        setIdPaciente(
            ''
        );


        setFechaDesde(
            getFechaHoy()
        );


        setErrorFormulario(
            ''
        );

    }, [
        isOpen
    ]);


    /*
    ====================================
    PACIENTES YA VINCULADOS
    EN LA FECHA SELECCIONADA
    ====================================
    */

    const pacientesVinculados =
        useMemo(() => {

            const ids =
                new Set();


            const listaAcuerdos =

                Array.isArray(
                    acuerdos
                )

                    ? acuerdos

                    : [];


            listaAcuerdos.forEach(
                (acuerdo) => {

                    if (
                        acuerdo
                            ?.activo ===
                            false
                    ) {

                        return;

                    }


                    const desde =
                        String(
                            acuerdo
                                ?.fecha_desde ||
                            ''
                        )
                            .substring(
                                0,
                                10
                            );


                    const hasta =

                        acuerdo
                            ?.fecha_hasta

                            ? String(
                                acuerdo
                                    .fecha_hasta
                            )
                                .substring(
                                    0,
                                    10
                                )

                            : null;


                    const aplicaFecha =

                        desde &&

                        desde <=
                            fechaDesde &&

                        (
                            !hasta ||

                            hasta >=
                                fechaDesde
                        );


                    if (
                        aplicaFecha
                    ) {

                        ids.add(
                            String(
                                acuerdo
                                    .id_paciente
                            )
                        );

                    }

                }
            );


            return ids;

        }, [
            acuerdos,
            fechaDesde
        ]);


    /*
    ====================================
    PACIENTES DISPONIBLES
    ====================================
    */

    const pacientesDisponibles =
        useMemo(() => {

            const listaPacientes =

                Array.isArray(
                    pacientes
                )

                    ? pacientes

                    : [];


            return listaPacientes
                .filter(
                    (paciente) => {

                        const id =
                            String(
                                getIdPaciente(
                                    paciente
                                )
                            );


                        return (

                            id &&

                            !pacientesVinculados
                                .has(
                                    id
                                )

                        );

                    }
                )
                .sort(
                    (
                        a,
                        b
                    ) => {

                        return getNombrePaciente(
                            a
                        )
                            .localeCompare(
                                getNombrePaciente(
                                    b
                                ),
                                'es'
                            );

                    }
                );

        }, [
            pacientes,
            pacientesVinculados
        ]);


    /*
    ====================================
    GUARDAR
    ====================================

    IMPORTANTE:

    CobroFormulario es un styled.div,
    no un form.

    Por eso NO usamos submit.

    El botón llama directamente a esta
    función mediante onClick.
    ====================================
    */

    const handleGuardar =
        async () => {

            if (
                guardando
            ) {

                return;

            }


            setErrorFormulario(
                ''
            );


            /*
            ====================================
            VALIDAR CENTRO
            ====================================
            */

            if (
                !centro?.id
            ) {

                setErrorFormulario(
                    'Seleccioná un centro.'
                );

                return;

            }


            /*
            ====================================
            VALIDAR PACIENTE
            ====================================
            */

            if (
                !idPaciente
            ) {

                setErrorFormulario(
                    'Seleccioná un paciente.'
                );

                return;

            }


            /*
            ====================================
            VALIDAR FECHA
            ====================================
            */

            if (
                !fechaDesde
            ) {

                setErrorFormulario(
                    'Indicá desde qué fecha se vincula el paciente.'
                );

                return;

            }


            /*
            ====================================
            VALIDAR CALLBACK
            ====================================
            */

            if (
                typeof onGuardar !==
                    'function'
            ) {

                setErrorFormulario(
                    'No se pudo iniciar la vinculación.'
                );

                return;

            }


            /*
            ====================================
            GUARDAR
            ====================================
            */

            const resultado =
                await onGuardar({

                    centro_id:
                        centro.id,

                    id_paciente:
                        idPaciente,

                    fecha_desde:
                        fechaDesde

                });


            /*
            ====================================
            ÉXITO
            ====================================

            El componente padre ya se encarga
            de cerrar el modal y mostrar el
            SweetAlert.
            ====================================
            */

            if (
                resultado ===
                    true ||

                resultado
                    ?.ok ===
                    true
            ) {

                return;

            }


            /*
            ====================================
            ERROR DEVUELTO POR EL PADRE
            ====================================
            */

            if (
                resultado
                    ?.msg
            ) {

                setErrorFormulario(
                    resultado.msg
                );


                return;

            }


            setErrorFormulario(
                'No se pudo vincular el paciente.'
            );

        };


    /*
    ====================================
    CERRAR
    ====================================
    */

    const handleCerrar = () => {

        if (
            guardando
        ) {

            return;

        }


        setErrorFormulario(
            ''
        );


        onClose();

    };


    /*
    ====================================
    RENDER
    ====================================
    */

    return (

        <Modal

            isOpen={
                isOpen
            }

            onRequestClose={
                handleCerrar
            }

            shouldCloseOnOverlayClick={
                !guardando
            }

            shouldCloseOnEsc={
                !guardando
            }

            style={{

                overlay: {

                    zIndex:
                        2000,

                    backgroundColor:
                        'rgba(0, 0, 0, 0.45)',

                    display:
                        'flex',

                    alignItems:
                        'center',

                    justifyContent:
                        'center',

                    padding:
                        '1rem'

                },

                content: {

                    position:
                        'relative',

                    inset:
                        'auto',

                    border:
                        'none',

                    background:
                        'transparent',

                    padding:
                        0,

                    width:
                        '100%',

                    maxWidth:
                        '600px',

                    maxHeight:
                        '90vh',

                    overflow:
                        'hidden',

                    boxSizing:
                        'border-box'

                }

            }}
        >

            <ModalEconomiaContenido>


                {/*
                ====================================
                CABECERA
                ====================================
                */}

                <ModalEconomiaCabecera>

                    <div>

                        <ModalEconomiaTitulo>
                            Vincular paciente
                        </ModalEconomiaTitulo>


                        <ModalEconomiaSubtitulo>

                            {
                                centro
                                    ?.nombre

                                    ? `Asigná un paciente a ${centro.nombre}.`

                                    : 'Asigná un paciente al centro.'
                            }

                        </ModalEconomiaSubtitulo>

                    </div>


                    <BotonCerrarModal

                        type="button"

                        onClick={
                            handleCerrar
                        }

                        disabled={
                            guardando
                        }
                    >
                        ×
                    </BotonCerrarModal>

                </ModalEconomiaCabecera>


                <ModalScrollContenido>


                    {/*
                    ====================================
                    CONTENIDO
                    ====================================
                    */}

                    <CobroFormulario>


                        <ModalSeccion>

                            <ModalSeccionTitulo>
                                Vinculación
                            </ModalSeccionTitulo>


                            {/*
                            ====================================
                            PACIENTE
                            ====================================
                            */}

                            {
                                pacientesDisponibles
                                    .length ===
                                    0

                                    ? (

                                        <SinInformacion>

                                            No hay pacientes
                                            disponibles para vincular
                                            en la fecha seleccionada.

                                        </SinInformacion>

                                    )

                                    : (

                                        <CobroCampo>

                                            <CobroLabel>
                                                Paciente *
                                            </CobroLabel>


                                            <CobroSelect

                                                value={
                                                    idPaciente
                                                }

                                                onChange={(e) => {

                                                    setIdPaciente(
                                                        e.target.value
                                                    );


                                                    setErrorFormulario(
                                                        ''
                                                    );

                                                }}

                                                disabled={
                                                    guardando
                                                }
                                            >

                                                <option
                                                    value=""
                                                >
                                                    Seleccioná un paciente
                                                </option>


                                                {
                                                    pacientesDisponibles
                                                        .map(
                                                            (
                                                                paciente
                                                            ) => {

                                                                const id =
                                                                    getIdPaciente(
                                                                        paciente
                                                                    );


                                                                return (

                                                                    <option

                                                                        key={
                                                                            id
                                                                        }

                                                                        value={
                                                                            id
                                                                        }
                                                                    >

                                                                        {
                                                                            getNombrePaciente(
                                                                                paciente
                                                                            )
                                                                        }

                                                                    </option>

                                                                );

                                                            }
                                                        )
                                                }

                                            </CobroSelect>

                                        </CobroCampo>

                                    )
                            }


                            {/*
                            ====================================
                            FECHA
                            ====================================
                            */}

                            <CobroCampo>

                                <CobroLabel>
                                    Vigente desde *
                                </CobroLabel>


                                <CobroInput

                                    type="date"

                                    value={
                                        fechaDesde
                                    }

                                    onChange={(e) => {

                                        setFechaDesde(
                                            e.target.value
                                        );


                                        /*
                                        Cambiar la fecha puede cambiar
                                        qué pacientes están disponibles.

                                        Por eso limpiamos la selección.
                                        */

                                        setIdPaciente(
                                            ''
                                        );


                                        setErrorFormulario(
                                            ''
                                        );

                                    }}

                                    disabled={
                                        guardando
                                    }
                                />

                            </CobroCampo>


                            {/*
                            ====================================
                            INFORMACIÓN
                            ====================================
                            */}

                            <div
                                style={{

                                    marginTop:
                                        '0.8rem',

                                    padding:
                                        '0.75rem 0.85rem',

                                    borderRadius:
                                        '8px',

                                    backgroundColor:
                                        '#F5FAFA',

                                    color:
                                        '#526363',

                                    fontSize:
                                        '0.76rem',

                                    lineHeight:
                                        1.45

                                }}
                            >

                                El paciente utilizará las
                                condiciones económicas generales
                                del centro.

                                Las condiciones particulares
                                se podrán configurar únicamente
                                cuando exista una excepción para
                                ese paciente.

                            </div>


                            {/*
                            ====================================
                            ERROR
                            ====================================
                            */}

                            {
                                errorFormulario

                                    ? (

                                        <div
                                            style={{

                                                marginTop:
                                                    '0.8rem',

                                                color:
                                                    '#C94B55',

                                                fontSize:
                                                    '0.78rem',

                                                fontWeight:
                                                    600

                                            }}
                                        >

                                            {
                                                errorFormulario
                                            }

                                        </div>

                                    )

                                    : null
                            }

                        </ModalSeccion>


                        {/*
                        ====================================
                        ACCIONES
                        ====================================
                        */}

                        <ModalAcciones>

                            <BotonSecundario

                                type="button"

                                onClick={
                                    handleCerrar
                                }

                                disabled={
                                    guardando
                                }
                            >
                                Cancelar
                            </BotonSecundario>


                            <BotonPrincipal

                                type="button"

                                onClick={
                                    handleGuardar
                                }

                                disabled={

                                    guardando ||

                                    !idPaciente ||

                                    pacientesDisponibles
                                        .length ===
                                        0
                                }
                            >

                                {
                                    guardando

                                        ? 'Vinculando...'

                                        : 'Vincular paciente'
                                }

                            </BotonPrincipal>

                        </ModalAcciones>

                    </CobroFormulario>

                </ModalScrollContenido>

            </ModalEconomiaContenido>

        </Modal>

    );

};


export default VincularPacienteCentroModal;